import { Instruction } from "@/routes/simulator/types";

const releaseStatuses = ["draft", "published"] as const;
export type ReleaseStatus = (typeof releaseStatuses)[number];

const releasePolicyItemTypes = ["general", "manual", "brief"] as const;
type ReleasePolicyItemType = (typeof releasePolicyItemTypes)[number];

interface BaseReleasePolicyItem {
  type: ReleasePolicyItemType;
  topic: string;
  subTopic: string;
  content: string;

  // might break something
}

export interface ReleaseComment {
  id: number;
  isAgent: boolean;
  comment: string;
  releaseConversationId: number;
  tenantId: string;
  createdAt: string;
  updatedAt: string;
}

const generalTopics = [
  "includeTicketSystem",
  "includeKnowledgeBase",
  "includeLink",
  "toneOfVoice",
  "openingLine",
  "closingLine",
  "maxBackAndForth",
  "strictMode",
] as const;
type GeneralTopic = (typeof generalTopics)[number];

interface GeneralReleasePolicyItem extends BaseReleasePolicyItem {
  type: "general";
  topic: GeneralTopic;
}

export type ReleasePolicyItem = GeneralReleasePolicyItem;

export function isReleasePolicyItem(obj: any): obj is ReleasePolicyItem {
  return (
    obj != null &&
    obj.hasOwnProperty("type") &&
    obj.hasOwnProperty("topic") &&
    obj.hasOwnProperty("subTopic")
  );
}

export type PostAnswerActionsConfig = {
  status?: string | null;
  tagsToAdd?: string[];
  customFields?: PostAnswerCustomField[];
};

export type PostAnswerCustomField = {
  fieldId: string;
  value: string | string[];
};

export interface Simulator {
  id: number;
  tenantId: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  releases: Release[];
  postAnswerActions?: PostAnswerActionsConfig;
}

export interface Release {
  id: number;
  releasePolicy: Instruction[];
  tenantId: string;
  status: ReleaseStatus;
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date | null;
  simulatorId: number;
}

const simulatorChannels = [
  "helpcenter",
  "autonomous_ticket_event",
  "autonomous_quackchat",
  "slackbot",
  "copilot",
  "knowledge_hub",
] as const;

export type SimulatorChannel = (typeof simulatorChannels)[number];

export const simulatorChannelToLabel: Record<SimulatorChannel, string> = {
  helpcenter: "Help Center",
  autonomous_ticket_event: "Tickets",
  autonomous_quackchat: "Live Chat",
  slackbot: "Slackbot",
  copilot: "Ticketing system AI Assistant",
  knowledge_hub: "Knowledge Hub",
};

export interface Simulator {
  id: number;
  tenantId: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  publishedReleaseId: number | null;
  draftReleaseId: number | null;
  channel: SimulatorChannel;
  shouldCloseTicket: boolean;
  releases: Release[];
}

export interface Instance extends Simulator {
  liveTopics: string[];
  liveVersion: number | null;
  conversations: any[];
}
